import { Injectable } from '@angular/core';
import { ApiVersion } from '@core/constants';
import { BaseResponse } from '@core/models/base-response';
import { BaseService } from '@core/services/base.service';

import { InvitationTokenModel } from './invitation-token.model';

@Injectable({
  providedIn: 'root',
})
export class UserCreateFirstPasswordService extends BaseService {
  readonly firstUserCreatePasswordUrl = 'users/invitations/{token}';
  readonly firstUserCreatePasswordUrl2 = 'users/invitations/by-token/{token}';

  sendSetPasswordRequest(
    token: string,
    password: string,
    passwordRepeat: string
  ) {
    let url = this.firstUserCreatePasswordUrl.replace('{token}', token);

    return this.post<BaseResponse<any>>(
      url,
      {
        password,
        passwordRepeat,
        userType: 'CUSTOMER',
      },
      {
        apiVersion: ApiVersion.V2,
        useRecaptcha: true,
      }
    );
  }

  validateUserFirstPasswordCreationToken(token: string) {
    let url = this.firstUserCreatePasswordUrl2.replace('{token}', token);
    return this.get<BaseResponse<InvitationTokenModel>>(url, {
      apiVersion: ApiVersion.V1,
      useAuthToken: false,
    });
  }
}
